export enum AppointmentActionErrors {
    ListingsAppointmentsLoading,
    ListingAppointmentsLoading,
    AppointmentCreation,
    AppointmentUpdate,
    AppointmentStatusUpdate,
    AppointmentDeletion,
    MarkAsViewed,
    ListingRemovedError
}